import { render } from "./ViewApprovisionnement.vue?vue&type=template&id=08f4de96&scoped=true&ts=true"
import script from "./ViewApprovisionnement.vue?vue&type=script&lang=ts"
export * from "./ViewApprovisionnement.vue?vue&type=script&lang=ts"

import "./ViewApprovisionnement.vue?vue&type=style&index=0&id=08f4de96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f4de96"]])

export default __exports__